import ExpressData from "../components/ExpressData";

const ExpressDataPage = () => {
  return <ExpressData />;
};

export default ExpressDataPage;
